import { useMemo } from "react";
import { debounce } from "src/shared/utils";
import { AnyType } from "src/shared/interfaces";

export default function useDebouncedFunction<F extends (...args: AnyType) => AnyType>(func?: F, delay = 500) {
  const debouncedFunction = useMemo(() => {
    if (!func) return;

    return debounce(func, delay);
  }, [func, delay]);
  return debouncedFunction;
}
